import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";

function WmsPoPhysicalStockCount_BreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/WmsPoPhysicalStock" ? (
        <div>
          <span className="breadcrumb-not-active ">PoPhysicalStock </span>
        </div>
      ) : vPathName === "/WmsPoPhysicalStockDetail" ? (
        <div className={"d-flex align-items-center"}>
          <Link
            to="/WmsPoPhysicalStock"
            state={location}
            className={"breadcrumb-active mr-2"}
          >
            PoPhysicalStock
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1px" }} />
          <div>
            <span className="breadcrumb-not-active">
              PoPhysicalStockDetail{" "}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default WmsPoPhysicalStockCount_BreadCrumbs;
